/* Cart-drawer "Get the pair" suggestion (Malou, 2026-08-24).
   When a cart line is one half of a Left/Right diptych cushion (handle ends -left-cushion /
   -right-cushion - the pair-note convention) and its partner is NOT in the cart, the partner
   is offered in a strip above Recently Viewed. The tile is fetched from the SAME
   section-rendering endpoint the recents strip uses (bokja-recently-viewed), so the look and
   the [data-bokja-quickadd] + button come for free - adding the partner morphs the drawer and
   the next pass sees the pair complete and hides the strip.

   Triggers: drawer open (the recents module's own two signals) plus a debounced observer on
   the drawer subtree, so in-drawer adds, removals and quantity changes recompute the offer.
   Fail-safe throughout: any error hides the strip and never touches the cart. */
(function () {
  if (window.__bokjaCartPairBound) return;
  window.__bokjaCartPairBound = true;

  var lastKey = null;
  var loading = false;

  function partnerOf(handle) {
    if (/-left-cushion$/.test(handle)) return handle.replace(/-left-cushion$/, '-right-cushion');
    if (/-right-cushion$/.test(handle)) return handle.replace(/-right-cushion$/, '-left-cushion');
    return null;
  }

  async function load() {
    if (window.__bokjaCartBusy) return;
    if (loading) return;
    var wrap = document.querySelector('[data-bokja-cart-pair]');
    var mount = wrap && wrap.querySelector('.bokja-recents__mount');
    if (!wrap || !mount) return;
    loading = true;
    try {
      var cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      var handles = cart.items.map(function (i) { return i.handle; });
      var missing = [];
      handles.forEach(function (h) {
        var partner = partnerOf(h);
        if (partner && handles.indexOf(partner) === -1 && missing.indexOf(partner) === -1) missing.push(partner);
      });
      if (!missing.length) { wrap.hidden = true; lastKey = null; return; }

      var key = missing.join(',');
      if (key === lastKey && mount.children.length) { wrap.hidden = false; return; }

      var ids = [];
      for (var i = 0; i < missing.length; i++) {
        try {
          var pj = await (await fetch('/products/' + missing[i] + '.js')).json();
          if (pj && pj.available) ids.push(pj.id);
        } catch (e) { /* partner unfetchable: skip it */ }
      }
      if (!ids.length) { wrap.hidden = true; lastKey = null; return; }

      var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
      var res = await fetch('/search?type=product&q=' + encodeURIComponent(q) + '&section_id=bokja-recently-viewed', { headers: { Accept: 'text/html' } });
      if (!res.ok) { wrap.hidden = true; return; }
      mount.innerHTML = (await res.text()).trim();
      var has = !!mount.querySelector('.bokja-recents__cell');
      wrap.hidden = !has;
      lastKey = has ? key : null;
    } catch (e) {
      wrap.hidden = true;
    } finally {
      loading = false;
    }
  }

  var debounce = null;
  function schedule() { clearTimeout(debounce); debounce = setTimeout(load, 350); }

  // Exactly the recents module's trigger shape (proven live), plus one scoped observer on
  // the items list so in-drawer adds/removals/quantity changes recompute the offer.
  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var d = muts[i].target;
      if (d.nodeType === 1 && d.classList && d.classList.contains('cart-drawer__dialog') && d.hasAttribute('open')) schedule();
    }
  });
  var itemsObs = new MutationObserver(function () { schedule(); });
  function watch() {
    var dlg = document.querySelector('.cart-drawer__dialog');
    if (dlg && !dlg.__bokjaPairWatched) {
      dlg.__bokjaPairWatched = true;
      obs.observe(dlg, { attributes: true, attributeFilter: ['open'] });
      if (dlg.hasAttribute('open')) schedule();
    }
    var items = document.querySelector('.cart-drawer__items');
    if (items && !items.__bokjaPairWatched) {
      items.__bokjaPairWatched = true;
      itemsObs.observe(items, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.bokja-nav__cart--trigger, [data-testid="cart-drawer-trigger"], [data-bokja-quickadd]');
    if (t) { watch(); setTimeout(schedule, 400); }
  }, true);

  // 2026-09-18 (James): the drawer can open by itself after an add and its dialog can be rebuilt, so the
  // [open] observer above is not enough. Three more triggers: the theme's own cart event, an [open]
  // observer over the whole page, and a quiet re-check every 4 s while the drawer is open.
  document.addEventListener('cart:update', function () { watch(); setTimeout(load, 400); });
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) { var d = muts[i].target; if (d.nodeType === 1 && d.classList && d.classList.contains('cart-drawer__dialog') && d.hasAttribute('open')) { watch(); setTimeout(load, 300); } }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['open'], subtree: true });
  setInterval(function () { if (document.querySelector('.cart-drawer__dialog[open]')) { watch(); load(); } }, 4000);
})();
